import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { Failed } from "@/common/components/info/info";
import { PriceChart } from "@/common/components/price-chart/price-chart";
import { useCurrentDateRange } from "@/common/components/quick-filters/quick-filters.hooks";
import { Spinner } from "@/common/components/spinner/spinner";
import { useCurrency } from "@/common/hooks/use-currency";
import { getSlashedQuarterName } from "@/common/utils/trading";

import { cropAggregatedPricesQuery } from "../../trades.api";

const PriceChartProvider = ({
  quarterName,
  cropId,
  storageId,
  traderId,
}: {
  quarterName: string;
  cropId: string;
  storageId: string;
  traderId: string;
}) => {
  const slashedQuarterName = getSlashedQuarterName(quarterName);
  const { dateFrom, dateTo } = useCurrentDateRange();
  const [, currency] = useCurrency();

  const prices = useQuery({
    ...cropAggregatedPricesQuery({
      cropId,
      // @ts-expect-error discrepancy between CF API and IDSign API
      currency,
      from: DateTime.fromISO(dateFrom),
      storageId,
      to: DateTime.fromISO(dateTo),
      traderId,
    }),
  });

  if (prices.status === "pending") {
    return (
      <PriceChart.Container>
        <div className="self-center">
          <Spinner />
        </div>
      </PriceChart.Container>
    );
  }

  if (prices.status === "error") {
    return (
      <PriceChart.Container>
        <div className="self-center">
          <Failed error={prices.error} />
        </div>
      </PriceChart.Container>
    );
  }

  const currentPrices = prices.data.filter(
    (d) => d.quarter.name === slashedQuarterName,
  );

  return (
    <PriceChart.Container>
      <PriceChart prices={currentPrices} />
    </PriceChart.Container>
  );
};

export { PriceChartProvider };
